import type { ReactNode } from "react";
import { styled } from "@pigment-css/react";

const Row = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.fieldSalesTwo.spacing[12],
}));

const SearchSlot = styled("div")({
  flex: "1 1 auto",
  minWidth: 0,
});

interface FilterHeaderRowProps {
  filterSlot?: ReactNode;
  children: ReactNode;
}

export function FilterHeaderRow({ filterSlot, children }: FilterHeaderRowProps) {
  if (!filterSlot) return <>{children}</>;
  return (
    <Row>
      <SearchSlot>{children}</SearchSlot>
      {filterSlot}
    </Row>
  );
}
